export const GET_LIST_INVOICE_BY_CUSTOMER = "GET_LIST_INVOICE_BY_CUSTOMER";
export const SEND_INVOICE = "SEND_INVOICE";
